'use strict';

const SELECTORS = {
    el: '#BambooHR',
    linksEl: '#BambooHR #BambooHR-ATS a',
};

(function () {
    const el = document.querySelector(SELECTORS.el);

    if (!el) {
        return;
    }

    const interval = setInterval(() => {
        const linksEl = document.querySelectorAll(SELECTORS.linksEl);

        if (!linksEl.length) {
            return;
        }

        setTimeout(() => {
            linksEl.forEach(linkEl => {
                linkEl.target = '_blank';
            });
        }, 100);

        clearInterval(interval);
    }, 500);
}());
